import { Store } from 'utils';

class Campaign extends Store {

	getInitialState() {
		return {
			saving: false,
			name: '',
			companyId: '',
			id: '',
			created: false
		}
	}

	onSelectedCampaignChanged(state, data) {
		state.name = data.campaign.title;
	}

	onCreateCampaign(state) {
		state.name = '';
	}

	onCampaignNameChanged(state, data) {
		state.name = data.name;
	}

	onCampaignCreated(state) {
		state.name = '';
	}

	onAddCampaign(state) {
		state.saving = true;
	}

	onCampaignSaved(state) {
		state.saving = false;
	}
	onCompanyidForUserChanged(state, data) {
		state.companyId = data.id;
	}
	onIdForUserChanged(state, data) {
		state.id = data.id;
	}
	onErrorCreateMap(state){
		state.created = true;
	}
	onSuccessCreateMap (state) {
		state.created = false;
	}
	onOpenCreateMap (state) {
		state.created = false;
	}
}

const campaign = new Campaign();
export default campaign;


// WEBPACK FOOTER //
// ./src/modules/model/CampaignStore.js